import { IAbout } from "../interfaces/about.interface";
import { IRequest } from "../interfaces/authentication.interface";
import { strapiRequest } from "./requests.service";

export const getAbout = async (locale: string): Promise<IRequest<IAbout>> => {
    try {
        const query = `
            query Content($locale: I18NLocaleCode) {
                aboutPageApp(locale: $locale) {
                    videoUrl
                    content
                }
            }`;

        const variables = {
            locale
        };

        const response = await strapiRequest.post<{ data: { aboutPageApp: IAbout } }>(`/graphql`, {
            operationName: "Content",
            query,
            variables
        });
        
        return { success: true, data: response.data?.data.aboutPageApp ?? "" };
    } catch (error: any) {
        return { success: false, data: [] as any };
    }
};
